"use client";
import styled from "styled-components";
import React from "react";
import IconArrowLeft from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconArrowLeft.js";
import { Text } from "@lmn/design-system";
import { BreadcrumbItem, Container, StyledLink } from "./BreadcrumbsClient";

const StyledIconArrowLeft = styled(IconArrowLeft)`
  fill: ${({ theme }) =>
    theme.kallisto.color.text.interactive.textPrimaryDefault};
`;

interface BreadcrumbsBackUrlProps {
  url: string;
}

export default function BreadcrumbsBackUrl({ url }: BreadcrumbsBackUrlProps) {
  return (
    <Container data-testid="breadcrumbs">
      <StyledIconArrowLeft size={12} />
      <BreadcrumbItem>
        <StyledLink href={url}>
          <Text variant="BodySmall">zurück zur Hotelauswahl</Text>
        </StyledLink>
      </BreadcrumbItem>
    </Container>
  );
}
